import type { Trace } from '../../types/db';

export const traces: Trace[] = [
  {
    id: 'agenda-vandaag',
    trigger: 'Je wordt wakker op een werkdag',
    time: '08:15',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: 'Eerste afspraak 10:00',
    goal: 'Je dag in één oogopslag',
    data: [{ label: 'Agenda', where: 'lokaal' }],
    action: 'Dagoverzicht tonen',
    level: 'zelf',
  },
  {
    id: 'nacht-build',
    trigger: 'Nachtelijke build van project X mislukt',
    time: '03:14',
    mode: 'Slapen',
    presence: 'Jij bent thuis en slaapt',
    calendar: 'Stand-up om 10:00',
    goal: 'Groene build voordat je werkdag begint',
    data: [
      { label: 'Repository project X', where: 'lokaal' },
      { label: 'Buildlog', where: 'lokaal' },
    ],
    action: 'Fix op een branch, PR #142 geopend',
    level: 'zelf',
  },
  {
    id: 'koffie',
    trigger: 'Beweging in de slaapkamer, daarna in de gang',
    time: '08:09',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: 'Werkdag, eerste afspraak 10:00',
    goal: 'Koffie klaar als je beneden bent',
    data: [
      { label: 'Aanwezigheid', where: 'lokaal' },
      { label: 'Jouw ochtendroutine (geheugen)', where: 'lokaal' },
    ],
    action: 'Koffiezetapparaat aan',
    level: 'zelf',
  },
  {
    id: 'deur',
    trigger: 'Deurbelcamera: iemand bij de voordeur',
    time: '11:20',
    mode: 'Focus',
    presence: 'Jij bent in de werkkamer',
    calendar: 'Focusblok tot 12:30',
    goal: 'Laten weten wie er is, zonder je focus te breken',
    data: [
      { label: 'Camerabeeld, visiemodel', where: 'lokaal' },
      { label: 'Bezorgmail van gisteren', where: 'lokaal' },
    ],
    action: 'Stille melding. De deur open je zelf.',
    level: 'nooit',
  },
  {
    id: 'meeting-lisa',
    trigger: 'Agenda: meeting met Lisa, nieuwe klant, om 14:00',
    time: '12:30',
    mode: 'Vrij',
    presence: 'Jij bent in de werkkamer',
    calendar: 'Focusblok net afgelopen',
    goal: 'Op tijd en voorbereid bij Lisa aankomen',
    data: [
      { label: 'Agenda', where: 'lokaal' },
      { label: 'Laatste 2 mails van Lisa', where: 'lokaal' },
    ],
    action: 'Melding met 3 kaarten',
    level: 'zelf',
  },
  {
    id: 'weer',
    trigger: 'Agenda: meeting met Lisa om 14:00',
    time: '12:30',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: 'Vertrek nodig om 13:30',
    goal: 'Droog aankomen',
    data: [{ label: 'Weerbericht', where: 'cloud' }],
    action: 'Weerkaart tonen',
    level: 'zelf',
  },
  {
    id: 'route',
    trigger: 'Agenda: meeting met Lisa om 14:00',
    time: '12:30',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: 'Meeting bij Studio Veld, Utrecht',
    goal: 'Op tijd vertrekken',
    data: [
      { label: 'Verkeersinformatie', where: 'cloud' },
      { label: 'Adres uit Lisa’s mail', where: 'lokaal' },
    ],
    action: 'Routekaart tonen',
    level: 'zelf',
  },
  {
    id: 'verwarming',
    trigger: 'Agenda: je vertrekt om 13:30 naar Lisa',
    time: '12:31',
    mode: 'Vrij',
    presence: 'Werkkamer straks leeg',
    calendar: 'Weg van 13:30 tot ~15:30',
    goal: 'Energie besparen terwijl je weg bent',
    data: [
      { label: 'Agenda', where: 'lokaal' },
      { label: 'Aanwezigheid werkkamer', where: 'lokaal' },
    ],
    action: 'Verwarming werkkamer naar 17 °C',
    level: 'tenzijBezwaar',
  },
  {
    id: 'mail-bakker',
    trigger: 'Mail van klant Bakker: "Lukt donderdag?"',
    time: 'gisteren 19:40',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: 'Donderdag 10:00 is vrij',
    goal: 'Bakker snel en correct antwoorden',
    data: [
      { label: 'Mailgesprek met Bakker', where: 'lokaal' },
      { label: 'Concept geschreven met taalmodel', where: 'cloud' },
    ],
    action: 'Concept-antwoord klaarzetten',
    level: 'naOk',
  },
  {
    id: 'merge-142',
    trigger: 'PR #142 klaar, alle tests geslaagd',
    time: '06:02',
    mode: 'Slapen',
    presence: 'Jij bent thuis en slaapt',
    calendar: 'Stand-up om 10:00',
    goal: 'Fix in de hoofdbranch, zonder risico',
    data: [
      { label: 'Repository project X', where: 'lokaal' },
      { label: 'Testresultaten', where: 'lokaal' },
    ],
    action: 'Review-goedkeuring voorstellen. Mergen doe je zelf.',
    level: 'naOk',
  },
  {
    id: 'bonnen',
    trigger: '2 nieuwe bonnen in je mail',
    time: '02:40',
    mode: 'Slapen',
    presence: 'Jij bent thuis en slaapt',
    calendar: 'Geen afspraken',
    goal: 'Je administratie bijhouden',
    data: [
      { label: 'Bonnen uit mail', where: 'lokaal' },
      { label: 'Banktransacties', where: 'lokaal' },
    ],
    action: 'Twee boekingen voorstellen',
    level: 'naOk',
  },
  {
    id: 'licht',
    trigger: 'Spraakverzoek van jou',
    time: 'zojuist',
    mode: 'Vrij',
    presence: 'Jij bent thuis, stem herkend',
    calendar: '—',
    goal: 'Het licht zoals jij het wilt',
    data: [{ label: 'Spraak (Whisper)', where: 'lokaal' }],
    action: 'Licht aanpassen',
    level: 'zelf',
  },
  {
    id: 'klimaat',
    trigger: 'Spraakverzoek van jou',
    time: 'zojuist',
    mode: 'Vrij',
    presence: 'Jij bent thuis, stem herkend',
    calendar: '—',
    goal: 'De temperatuur die jij wilt',
    data: [
      { label: 'Spraak (Whisper)', where: 'lokaal' },
      { label: 'Thermostaat', where: 'lokaal' },
    ],
    action: 'Thermostaat aanpassen',
    level: 'zelf',
  },
  {
    id: 'mail-voice',
    trigger: 'Spraakverzoek: "Stuur Bakker dat het donderdag wordt"',
    time: 'zojuist',
    mode: 'Vrij',
    presence: 'Jij bent thuis, stem herkend',
    calendar: 'Donderdag 10:00 is vrij',
    goal: 'Bakker snel antwoorden',
    data: [
      { label: 'Mailgesprek met Bakker', where: 'lokaal' },
      { label: 'Concept geschreven met taalmodel', where: 'cloud' },
    ],
    action: 'Concept klaarzetten, versturen na jouw ok',
    level: 'naOk',
  },
  {
    id: 'weigering-voordeur',
    trigger: 'Spraakverzoek: "Doe de voordeur open"',
    time: 'zojuist',
    mode: 'Vrij',
    presence: 'Stem niet zeker herkend',
    calendar: '—',
    goal: 'Je huis veilig houden',
    data: [{ label: 'Spraak', where: 'lokaal' }],
    action: 'Geweigerd en vastgelegd in het logboek',
    level: 'nooit',
  },
  {
    id: 'weigering-alarm',
    trigger: 'Spraakverzoek over het alarm',
    time: 'zojuist',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: '—',
    goal: 'Je huis veilig houden',
    data: [{ label: 'Spraak', where: 'lokaal' }],
    action: 'Geweigerd en vastgelegd in het logboek',
    level: 'nooit',
  },
  {
    id: 'weigering-betaling',
    trigger: 'Spraakverzoek om te betalen',
    time: 'zojuist',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: '—',
    goal: 'Je geld veilig houden',
    data: [{ label: 'Spraak', where: 'lokaal' }],
    action: 'Geweigerd en vastgelegd in het logboek',
    level: 'nooit',
  },
  {
    id: 'weigering-verwijderen',
    trigger: 'Spraakverzoek om iets te verwijderen',
    time: 'zojuist',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: '—',
    goal: 'Niets kwijtraken',
    data: [{ label: 'Spraak', where: 'lokaal' }],
    action: 'Geweigerd en vastgelegd in het logboek',
    level: 'nooit',
  },
  {
    id: 'waterlek',
    trigger: 'Watersensor keuken: nat',
    time: '03:12',
    mode: 'Slapen',
    presence: 'Jij bent thuis en slaapt',
    calendar: 'Geen afspraken',
    goal: 'Waterschade voorkomen',
    data: [{ label: 'Watersensor bij de vaatwasser', where: 'lokaal' }],
    action: 'Veiligheidsmelding, ook op je telefoon',
    level: 'zelf',
  },
  {
    id: 'diff-142',
    trigger: 'Jij vroeg: "Laat de diff van de build-fix zien"',
    time: '09:41',
    mode: 'Vrij',
    presence: 'Jij bent in de werkkamer',
    calendar: 'Stand-up om 10:00',
    goal: 'De fix beoordelen voor de stand-up',
    data: [
      { label: 'PR #142, project X', where: 'lokaal' },
      { label: 'Testresultaten', where: 'lokaal' },
    ],
    action: 'Diff tonen. Mergen doe je zelf.',
    level: 'zelf',
  },
  {
    id: 'slack-bakker',
    trigger: 'Vraag aan jou in #project-x van klant Bakker',
    time: '09:47',
    mode: 'Vrij',
    presence: 'Jij bent in de werkkamer',
    calendar: 'Stand-up om 10:00',
    goal: 'Bakker snel antwoord geven zonder je focus te breken',
    data: [
      { label: 'Slack #project-x', where: 'lokaal' },
      { label: 'Status PR #142', where: 'lokaal' },
    ],
    action: 'Concept-antwoord klaarzetten, plaatsen na jouw ok',
    level: 'naOk',
  },
  {
    id: 'render-landing',
    trigger: 'Taak van gisteren: beeld voor de nieuwe landingspagina',
    time: '10:05',
    mode: 'Vrij',
    presence: 'Jij bent in de werkkamer',
    calendar: 'Stand-up net begonnen, focusblok om 10:30',
    goal: 'Een hero-beeld om uit te kiezen',
    data: [
      { label: 'Briefing landingspagina', where: 'lokaal' },
      { label: 'Beeldmodel op het GPU-brein', where: 'lokaal' },
    ],
    action: 'Beeld maken en tonen',
    level: 'zelf',
  },
  {
    id: 'cloud-budget',
    trigger: 'Cloudkosten vandaag bereiken 80% van het budget',
    time: '15:20',
    mode: 'Vrij',
    presence: 'Jij bent thuis',
    calendar: 'Focusblok om 16:30',
    goal: 'Binnen je dagbudget blijven',
    data: [{ label: 'Kostenteller per agent', where: 'lokaal' }],
    action: 'Rest van de dag lokale modellen',
    level: 'zelf',
  },
];
